import { render, staticRenderFns } from "./chatGrupos.vue?vue&type=template&id=aa5b8572&scoped=true"
import script from "./chatGrupos.vue?vue&type=script&lang=js"
export * from "./chatGrupos.vue?vue&type=script&lang=js"
import style0 from "./chatGrupos.vue?vue&type=style&index=0&id=aa5b8572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5b8572",
  null
  
)

export default component.exports